import bg from '../../assets/banner.png';

const Header = () => {
  return (
    <div className=" rounded-t-xl text-center relative flex flex-col items-center w-full">
      <div className="bg-blue-300 rounded-t-xl text-center relative flex flex-col items-center w-full">
        <img src={bg} alt="Banner RKDTIP 2025" className="w-full" />
      </div>
      {/* CONTENT */}
      <div className="py-6 leading-relaxed text-justify text-gray-800">
        <h2 className="font-bold text-xl mb-4">
          Konfirmasi Kehadiran Rakor Data dan Teknologi Informasi Pendidikan
          2025
        </h2>

        <p className="mb-4">
          Dalam rangka pelaksanaan Rapat Koordinasi Data dan Teknologi Informasi
          Pendidikan dengan Tema:
          <span className="italic">
            “Penguatan Ekosistem Data Pendidikan dan Digitalisasi Pembelajaran
            untuk Mewujudkan Indonesia Cerdas dalam Kerangka Asta Cita”
          </span>{' '}
          pada Senin s.d. Kamis, 15 s.d. 18 Desember 2025 di Grand Sahid Jaya
          Jakarta, Bapak/Ibu peserta yang akan hadir mohon mengisi formulir
          konfirmasi kehadiran dengan lengkap. Perlu kami informasikan bahwa:
        </p>

        <ol className="list-decimal pl-6 mb-4">
          <li>
            Panitia menanggung semua biaya kegiatan untuk 1 (satu) orang
            peserta;
          </li>
          <li>
            Konfirmasi kehadiran peserta dilengkapi paling lambat Jumat, 12
            Desember 2025 pukul 17.00 WIB;
          </li>
          <li>
            Peserta yang akan hadir mohon bergabung dalam WA Group Rakor melalui
            tautan:{' '}
            <a
              href="https://s.id/join_wag_rakor"
              target="_blank"
              className="text-blue-600 underline">
              https://s.id/join_wag_rakor
            </a>
          </li>
          <li>
            Para Peserta baru dapat masuk ke kamar hotel masing-masing (proses
            check-in) pada hari Senin, 15 Desember 2025 pukul 14.00 WIB
          </li>
          <li>
            ⁠Para peserta dapat menitipkan barang bawaannya kepada petugas
            setelah peserta melakukan proses registrasi
          </li>
          <li>
            Para peserta diimbau untuk sudah mulai memberikan bukti
            administratif perjalanan dari hari kedatangan (hari 1)
          </li>
          {/* <li>
            Bagi bapak/ibu yang belum membeli tiket akan di bantu untuk
            pemesanannya.
          </li> */}
        </ol>

        <p className="mb-1">
          Atas perhatian Bapak/Ibu, kami ucapkan terima kasih.
        </p>
        <p className="font-semibold">Sampai bertemu di Jakarta!</p>
      </div>
    </div>
  );
};

export default Header;
